import React, { useContext } from "react";
import { authGetRequest, getRequest } from "../../api/laravel/public/api";
import { settingContext } from "../../context/Setting/Setting";
import {
  CourseSection,
  Footer,
  MenuBar,
  Offer,
  Slide,
  Stat,
  Summary,
} from "../../layout/welcome";

import { _retrieveData, _storeData } from "../../utils/local-storage";

import "./welcome.scss";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { AuthContext } from "../../context/auth/ApiContext";

const Welcome = () => {
  // const { page} = useContext(settingContext);
  const [page, setPage] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const { user } = React.useContext(AuthContext);
  const router = useHistory();


  React.useEffect(() => {
    initialApi();
    // checkUser();
  }, []);

  const initialApi = async () => {
    setLoading(true);
    const pageData = await _retrieveData("page_data");
    if (pageData) {
      setPage(pageData);
      setLoading(true);
    }
    const { data_r, message, isError, isLoading } = await getRequest(
      `/auth/api/page`
    );
    setPage(data_r);
    setLoading(false);
    await _storeData(data_r, "page_data");
  };


  return (
    <div id="page-top" class="home">
      <div id="page-wrap">
        <MenuBar
          menuIndex="home"
          setting={page?.setting}
          loader={loading} />
        <Slide
          slide={page?.page_slide} />

        <Offer
          offer={page?.page_offer} />

        <Summary
          user={user}
          about={page?.about_section}
        />

        <CourseSection
          section={page?.course_section}
          user={user} />

        <Footer
          setting={page?.setting} />
      </div>
    </div>
  );
};

export default Welcome;